import React, { useEffect, useState } from 'react';
import { Select } from '@consta/uikit/Select';
import { TextField } from '@consta/uikit/TextField';
import { Button } from '@consta/uikit/Button';
import { IconSearchStroked } from '@consta/icons/IconSearchStroked';
//@ts-ignore
import classes from './style/FilterSection.module.scss'
import { useLazyGetCompanyQuery } from '../../../../services/companyService';
import { useLazyGetReservoirQuery } from '../../../../services/reservoirService';
import { useLazyGetFieldTypeQuery } from '../../../../services/fieldService';

interface FilterSectionProps {
    itemsCompanySelect?: any[];
    itemsTypeSelect?: any[];
    itemsStageSelect?: any[];
    onCompanyChange?: (value: any) => void;
    onTypeChange?: (value: any) => void;
    onStageChange?: (value: any) => void;
    onSearchChange?: (value: string) => void;
    onSearch?: () => void;
    searchValue?: string;
    onClearFilters?: () => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
    onCompanyChange,
    onTypeChange,
    onStageChange,
    onSearchChange,
    onSearch,
    searchValue = '',
    onClearFilters
}) => {
    // Lazy запросы к API
    const [triggerGetCompanies, { data: companiesData, isLoading: companiesLoading }] = useLazyGetCompanyQuery();
    const [triggerGetReservoirTypes, { data: reservoirTypesData, isLoading: reservoirTypesLoading }] = useLazyGetFieldTypeQuery();

    // Локальные состояния для выбранных значений
    const [selectedCompany, setSelectedCompany] = useState<any>(null);
    const [selectedType, setSelectedType] = useState<any>(null);
    const [selectedStage, setSelectedStage] = useState<any>(null);
    const [localSearchValue, setLocalSearchValue] = useState<string>(searchValue);

    // Загрузка данных при монтировании компонента
    useEffect(() => {
        triggerGetCompanies({
            limit: 100,
            offset: 0,
            ordering: 'name'
        });
        
        triggerGetReservoirTypes({});
    }, [triggerGetCompanies, triggerGetReservoirTypes]);

    // Синхронизация с внешним searchValue
    useEffect(() => {
        setLocalSearchValue(searchValue);
    }, [searchValue]);

    // Преобразование данных компаний для Select
    const companyOptions = companiesData?.results?.map(company => ({
        id: company.uuid,
        label: company.name,
        value: company.uuid
    })) || [];

    // Добавляем опцию "Все компании"
    const allCompanyOptions = [
        { id: 'all', label: 'Все компании', value: '' },
        ...companyOptions
    ];

    // Преобразование данных типов коллекторов для Select
    const typeOptions = reservoirTypesData ? Object.values(reservoirTypesData).map((type: any) => ({
        id: type.uuid,
        label: type.name,
        value: type.uuid
    })) : [];

    // Добавляем опцию "Все типы"
    const allTypeOptions = [
        { id: 'all', label: 'Все типы', value: '' },
        ...typeOptions
    ];

    // Опции для стадий (числа от 1 до 5)
    const stageOptions = [
        { id: 'all', label: 'Все стадии', value: '' },
        { id: 1, label: '1', value: '1' },
        { id: 2, label: '2', value: '2' },
        { id: 3, label: '3', value: '3' },
        { id: 4, label: '4', value: '4' },
        { id: 5, label: '5', value: '5' }
    ];

    // Обработчики изменений
    const handleCompanyChange = (value: any) => {
        setSelectedCompany(value);
        if (onCompanyChange) {
            onCompanyChange(value);
        }
    };

    const handleTypeChange = (value: any) => {
        setSelectedType(value);
        if (onTypeChange) {
            onTypeChange(value);
        }
    };

    const handleStageChange = (value: any) => {
        setSelectedStage(value);
        if (onStageChange) {
            onStageChange(value);
        }
    };

    const handleSearchChange = (value: string | null) => {
        const searchText = value || '';
        setLocalSearchValue(searchText);
        if (onSearchChange) {
            onSearchChange(searchText);
        }
    };

    const handleSearchClick = () => {
        if (onSearch) {
            onSearch();
        }
    };

    // Очистка фильтров
    const handleClearFilters = () => {
        setSelectedCompany(null);
        setSelectedType(null);
        setSelectedStage(null);
        setLocalSearchValue('');
        if (onClearFilters) {
            onClearFilters();
        }
        // Также вызываем обработчики с null
        if (onCompanyChange) onCompanyChange(null);
        if (onTypeChange) onTypeChange(null);
        if (onStageChange) onStageChange(null);
        if (onSearchChange) onSearchChange('');
    };

    // Обновление данных по кнопке "Обновить"
    const handleRefreshData = () => {
        triggerGetCompanies({
            limit: 100,
            offset: 0,
            ordering: 'name'
        });
        triggerGetReservoirTypes({});
    };

    const hasActiveFilters = selectedCompany || selectedType || selectedStage || localSearchValue;

    return (
        <div className={classes.filter}>
            <Select
                items={allCompanyOptions}
                value={selectedCompany}
                onChange={handleCompanyChange}
                size='s'
                placeholder="Компания"
                isLoading={companiesLoading}
            />
            <Select
                items={allTypeOptions}
                value={selectedType}
                onChange={handleTypeChange}
                size='s'
                placeholder="Тип"
                isLoading={reservoirTypesLoading}
            />
            <Select
                items={stageOptions}
                value={selectedStage}
                onChange={handleStageChange}
                size='s'
                placeholder="Стадия"
            />
            <TextField 
                placeholder='Поиск по названию и описанию' 
                size='s' 
                value={localSearchValue}
                onChange={handleSearchChange}
            />
        </div>
    );
};

export default FilterSection;